import { AutomationValue } from '../../../automation/ast/AutomationValue.js';

/** Find a `{ key, value: AutomationValue }` parameter entry, or null. */
export function getParam(parameters, key) {
  return parameters.find(p => p.key === key) ?? null;
}

/** Read a parameter's value as a plain string. */
export function getParamValue(parameters, key, fallback = '') {
  return getParam(parameters, key)?.value?.toString() ?? fallback;
}

/** Set (or insert) a parameter as a literal string value. */
export function setParam(parameters, key, value) {
  const existing = getParam(parameters, key);
  if (existing) {
    existing.value = AutomationValue.literal(value);
  } else {
    parameters.push({ key, value: AutomationValue.literal(value) });
  }
}

export function removeParam(parameters, key) {
  const idx = parameters.findIndex(p => p.key === key);
  if (idx !== -1) parameters.splice(idx, 1);
}
